// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { max as fn } from "../max.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const maxWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default maxWithOptions;
